import { Checkbox, FormControlLabel, TextField } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ApplicationRestrictionDto, EntityTypes } from '../../common/PricePrgClient';
import { updateApplicationRestriction } from './redux/settingsSlices';

type Props = {
    applicationRestriction: ApplicationRestrictionDto;
};

export const ApplicationRestrictionRow = ({ applicationRestriction }: Props) => {
    const [appSettingVal, setAppSettingVal] = useState(applicationRestriction);
    const dispatch = useDispatch();

    useEffect(() => {
        setAppSettingVal(applicationRestriction);
    }, [applicationRestriction]);

    const tableTypeName = useMemo(() => {
        switch (applicationRestriction.entityType) {
            case EntityTypes.Contact:
                return 'Contact';
            case EntityTypes.Pricelist:
                return 'Pricelist';
            case EntityTypes.Customer:
                return 'Customer';
            case EntityTypes.Agreement:
                return 'Agreement';
            case EntityTypes.PricelistConnection:
                return 'Pricelist connection';
            case EntityTypes.Product:
                return 'Product';
            default:
                return applicationRestriction.entityType;
        }
    }, [applicationRestriction.entityType]);

    const handleCreateChanged = (checked: boolean) => {
        const request = { ...appSettingVal, isCreateDisabled: checked };
        setAppSettingVal(request);
        dispatch(updateApplicationRestriction.request(request));
    };

    const handleDeleteChanged = (checked: boolean) => {
        const request = { ...appSettingVal, isDeleteDisabled: checked };
        setAppSettingVal(request);
        dispatch(updateApplicationRestriction.request(request));
    };

    return (
        <Box>
            <TextField sx={{ padding: 1 }} value={tableTypeName} disabled />
            <FormControlLabel
                label="Disable create"
                sx={{ mt: 2 }}
                control={
                    <Checkbox
                        checked={appSettingVal.isCreateDisabled}
                        onChange={(_, checked) => handleCreateChanged(checked)}
                    />
                }
            />
            <FormControlLabel
                sx={{ mt: 2 }}
                label="Disable delete"
                control={
                    <Checkbox
                        checked={appSettingVal.isDeleteDisabled}
                        onChange={(_, checked) => handleDeleteChanged(checked)}
                    />
                }
            />
        </Box>
    );
};
